module.exports = __webpack_public_path__ + "img/violet_138.de992375.png";